import { render, staticRenderFns } from "./MsTrader.vue?vue&type=template&id=439fe50b&scoped=true&"
import script from "./MsTrader.vue?vue&type=script&lang=js&"
export * from "./MsTrader.vue?vue&type=script&lang=js&"
import style0 from "./MsTrader.vue?vue&type=style&index=0&id=439fe50b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439fe50b",
  null
  
)

export default component.exports